var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChildProperty, Property } from '@syncfusion/ej2-base';
/**
 * Configures the background color settings of the Block Editor component.
 * Use this class to customize background color options including default color, display mode (palette or picker), grid layout, and custom color palettes for text highlighting and emphasis.
 */
export class BackgroundColorSettings extends ChildProperty {
}
__decorate([
    Property('#ffff00')
], BackgroundColorSettings.prototype, "default", void 0);
__decorate([
    Property('Palette')
], BackgroundColorSettings.prototype, "mode", void 0);
__decorate([
    Property(10)
], BackgroundColorSettings.prototype, "columns", void 0);
__decorate([
    Property(null)
], BackgroundColorSettings.prototype, "colorCode", void 0);
__decorate([
    Property(false)
], BackgroundColorSettings.prototype, "modeSwitcher", void 0);
